exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__FHAPanel__panel__lifK4 {\n  background: white;\n  height: auto;\n  position: relative;\n}\n\n.dmb-web__FHAPanel__segment__SvGg7 {\n  background-color: #eee;\n  padding: 10px 0;\n  position: sticky;\n  text-align: center;\n  top: 0;\n  z-index: 1;\n}\n\n.dmb-web__FHAPanel__tabs__e5l3A {\n  background-color: white;\n  text-align: center;\n}\n\n.dmb-web__FHAPanel__events__QZpP9 {\n  background: white;\n  height: auto;\n}\n", ""]);

// exports
exports.locals = {
	"panel": "dmb-web__FHAPanel__panel__lifK4",
	"segment": "dmb-web__FHAPanel__segment__SvGg7",
	"tabs": "dmb-web__FHAPanel__tabs__e5l3A",
	"events": "dmb-web__FHAPanel__events__QZpP9"
};